export default __webpack_public_path__ + "static/media/Poirier Group.29fed1ca.png";